import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Delete } from '@material-ui/icons';


// eslint-disable-next-line react/prop-types
const GroupTitle = ({ title }) =>
  <Typography style={{ fontWeight: 800, lineHeight: 2 }} variant="overline" component="div">{title}</Typography>;

const useStyle = makeStyles(theme => ({
  box: {
    backgroundColor: 'rgb(51, 136, 255)',
    borderRadius: '3px',
  },
  icon: {
    fontSize: '18px',
  },
  actionIcons: {
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.common.gray600,
    cursor: 'pointer',
    height: theme.spacing(2.5),
    width: theme.spacing(2.5),
    '&:hover': {
      color: theme.palette.common.gray800,
      backgroundColor: theme.palette.common.lightGray,
    },
  },
}));

const InterestAreasLegend = props => {
  const { layers = [], deleteInterestArea } = props;
  const classes = useStyle();
  const hasLayers = layers && layers.length > 0;
  return (
    hasLayers && <Box p={0.5} marginLeft={0.5}>
      <GroupTitle title="Área de interés" />
      <Box display="flex" justifyContent="center" flexDirection="column">
        {layers.map(l =>
          <Box key={l.id} display="flex" alignItems="center">
            <Box height={12} width={12} mr={0.5} style={{
              backgroundColor: '#00e500',
              borderRadius: '3px',
            }} className ={ classes.box} />
            <Typography variant="body2">{l.name}</Typography>
            <Box ml={1} flexGrow={1} />
            <Box display="flex" width="100%" alignItems="center" className={classes.actionIcons} px={0.1}>
              <Delete className={classes.icon} onClick={() => deleteInterestArea(l.id)} />
            </Box>
          </Box>,
        )}
      </Box>
    </Box>
  );
};

InterestAreasLegend.propTypes = {
  layers: PropTypes.array,
  hasOccurrencesLayer: PropTypes.bool,
  deleteInterestArea: PropTypes.func,
  hideTileLayer: PropTypes.func,
  displayOnMap: PropTypes.object,
  deletePermission: PropTypes.bool,
  hasSatInfo: PropTypes.bool,
};


export {
  InterestAreasLegend,
};
